import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import axiosInstance from "@/lib/axiosInstance.ts";
import { MobileFormEndpoints } from "@/api/mobile/form.ts";
import { DynamicForm } from "@/components/domain/WorkOrder/Mobile/DynamicForm/DynamicForm";
import type { FormPage } from "@/components/features/FormBuilder/types/form.types";
import { DynamicFormFooter } from "@/components/domain/WorkOrder/Mobile/DynamicForm/DynamicFormFooter/DynamicFooter.tsx";
import { MobileFooter } from "@onengine/component-library";
import { MobileNavbarTemp } from "@/components/domain/WorkOrder/Mobile/MobileNavbar/MobileNavbar.tsx";
import { authGuardWithPermissions } from "@/utils/authGuard.ts";
import type { RouterContextType } from "@/api/permissions/permissions.api.ts";

export const Route = createFileRoute("/_authenticated/mobile/work-order/check-in/$id/")({
  component: CheckInMobileDynamicForm,
  beforeLoad: async (args) => {
    await authGuardWithPermissions({
      context: args.context as RouterContextType,
      location: args.location as { pathname: string },
    });
  },
});

function CheckInMobileDynamicForm() {
  const formId = import.meta.env.VITE_CHECK_IN_FORM_ID || "019edfaa-ad99-7381-b226-5e14085f10bb";

  const { data, isLoading } = useQuery({
    queryKey: ["form", formId],
    queryFn: async () => {
      const response = await axiosInstance.get(`${MobileFormEndpoints.getById}/${formId}`);
      return response.data;
    },
  });

  const pages: FormPage[] = data?.data?.structure ?? [];

  if (isLoading) return null;

  return (
    <div style={{ width: "100%", minHeight: "100vh", height: "100%", overflow: "hidden" }}>
      <MobileNavbarTemp>Check-In</MobileNavbarTemp>
      <DynamicForm
        pages={pages}
        onSubmit={(formData) =>
          // TODO: Kennedy - ask team about an endpoint to submit the dynamic form
          // eslint-disable-next-line no-console
          console.log(formData)
        }
      >
        <DynamicFormFooter />
      </DynamicForm>
      <MobileFooter>teste</MobileFooter>
    </div>
  );
}
